import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CasesState } from '../../types';

const initialState: CasesState = {
    email: "",
    loading: false,
    errorMessage: null,
    loadCases: false,
    verifiedEntity: null,
    caseModal: false,
    editModal: false,
    caseRow: null,
    checkEmail: false,
    cases: [],
    closedCases: [],
    searchText: "",
    sortColumn: 'Id',
    sortColumnDirection: {
        Id: 'desc',
    },
    items: [],
    selection: [],
    linkExpired: false,
    closeModal: false,
    saving: false
};

export const caseSlice = createSlice({
  name: 'case',
  initialState,
  reducers: {
    loadCases: () => {

    }
  },
  extraReducers() {
    // builder.addCase(logoutUser, (state) => {
    //   state.isLoggingOut = true;
    // });
  }
});

export type CaseState = { [caseSlice.name]: ReturnType<typeof caseSlice.reducer> };

export const { loadCases } = caseSlice.actions;

export const caseReducer = caseSlice.reducer;
